import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../contexts/GlobalContext';
import './NotFound.css'
import Btn from '../../components/Btn/Btn';
import getImage from '../../useFull/getImage';

const cardNotFound = (label, backLabel, backPath, _nav) => {
    return (
        <div className='card-not-found-container'>
            <div className='card-not-found-b1'>
                <span className='text-title-secondary mg-bot-20'>{label}</span>
                <Btn
                    label={backLabel}
                    type={'link'}
                    textColor={'var(--primary300)'}
                    _function={() => _nav(backPath)}
                />
            </div>
            <div style={{ backgroundImage: `url(${getImage('icons', 'air-plane.png')})`, width: '60px' }} className='bg-icon'></div>
        </div>
    )
}

const footerNotFound = (label) => {
    const date = new Date()
    return (
        <div className='main-container bg-gray100'>
            <section className="section-container">

                <div className='footer-not-found'>
                    <span className='legend'>{label} {date.getFullYear()}</span>
                </div>
            </section>
        </div>
    )
}

const NotFound = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const texts = require(`../../assets/languages/${language}/notFound.json`);
    const footerRef = useRef(null);
    const navigate = useNavigate();
    useEffect(() => {
        // Adiciona o estilo display: none ao renderizar o componente
        footerRef.current = document.querySelector('.footer-app-container');
        if (footerRef.current) {
            footerRef.current.style.display = 'none';
        }

        // Remove o estilo display: none ao desmontar o componente
        return () => {
            if (footerRef.current) {
                footerRef.current.style.display = '';
            }
        };
    }, []);

    return (
        <>
            <div className='main-container'>
                <section className="section-container">
                    <div className='not-found-container'>
                        <span className='text-title-secondary primary300 mg-bot-30'>{texts.t1}</span>
                        <span dangerouslySetInnerHTML={{ __html: texts.t2 }} className='legend mg-bot-30'></span>
                        {cardNotFound(texts.t3, texts.backButton, `${language !== 'pt-br' ? `/${language}` : '/'}`, navigate)}

                    </div>
                </section>
            </div>
            {footerNotFound(texts.footer)}
        </>
    );
};

export default NotFound;